export default "__VITE_PUBLIC_ASSET__f003ec3c__"